var _circle, _path, _circle2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPeople = function SvgPeople(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.302,
    cy: 8.319,
    r: 3.056,
    stroke: "#181800",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#181800",
    strokeWidth: 1.5,
    d: "M14.052 14.24a4.585 4.585 0 0 1 8.665.483c.186.665-.391 1.236-1.081 1.236h-6.771"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.99,
    cy: 6.219,
    r: 4.583,
    stroke: "#181800",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#181800",
    strokeWidth: 1.5,
    d: "M7.99 10.802a6.88 6.88 0 0 0-6.763 5.631c-.124.68.447 1.244 1.137 1.244h11.25c.69 0 1.262-.565 1.138-1.244a6.88 6.88 0 0 0-6.763-5.631Z"
  })));
};
export { SvgPeople as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMTkiIGZpbGw9Im5vbmUiPgogIDxjaXJjbGUgY3g9IjE4LjMwMiIgY3k9IjguMzE5IiByPSIzLjA1NiIgc3Ryb2tlPSIjMTgxODAwIiBzdHJva2Utd2lkdGg9IjEuNSIvPgogIDxwYXRoIHN0cm9rZT0iIzE4MTgwMCIgc3Ryb2tlLXdpZHRoPSIxLjUiIGQ9Ik0xNC4wNTIgMTQuMjRhNC41ODUgNC41ODUgMCAwIDEgOC42NjUuNDgzYy4xODYuNjY1LS4zOTEgMS4yMzYtMS4wODEgMS4yMzZoLTYuNzcxIi8+CiAgPGNpcmNsZSBjeD0iNy45OSIgY3k9IjYuMjE5IiByPSI0LjU4MyIgc3Ryb2tlPSIjMTgxODAwIiBzdHJva2Utd2lkdGg9IjEuNSIvPgogIDxwYXRoIHN0cm9rZT0iIzE4MTgwMCIgc3Ryb2tlLXdpZHRoPSIxLjUiIGQ9Ik03Ljk5IDEwLjgwMmE2Ljg3NyA2Ljg3NyAwIDAgMC02Ljc2MyA1LjYzMWMtLjEyNC42OC40NDcgMS4yNDQgMS4xMzcgMS4yNDRoMTEuMjVjLjY5IDAgMS4yNjItLjU2NSAxLjEzOC0xLjI0NGE2Ljg3NyA2Ljg3NyAwIDAgMC02Ljc2My01LjYzMVoiLz4KPC9zdmc+Cg==";